import api from './AxiosInstance';

export class BpiService {

 getBonAchat  = async () => {
    try {
      const response = await api.get(`/BonAchat/List?perim=IPM`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  

  AddBonAchat  = async (bon) => {
    try {
      const response = await api.post(`/BonAchat/add`, bon);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  
  UpdateBonAchat  = async (bon) => {
    try {
      const response = await api.post(`/BonAchat/update`, bon);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  

  EditBonAchat  = async (numba) => {
    try {
      const response = await api.get(`/BonAchat/Edit?numBA=${numba}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  deleteBon  = async (numba) => {
    try {
      const response = await api.delete(`/BonAchat/${numba}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  AddDoc  = async (docData) => {
    try {
      const response = await api.post(`/Document/IPM/add`,docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  FacAddDoc  = async (docData) => {
    try {
      const response = await api.post(`/Facture/Adherent/add`,docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  
  AddOrdrePaie  = async (docData) => {
    try {
      const response = await api.post(`/LettreCheque/add`,docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  UpdateOrdrePaie  = async (docData) => {
    try {
      const response = await api.put(`/LettreCheque/update`,docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  FacEditDoc  = async (docData) => {
    try {
      const response = await api.put(`/Facture/Adherent/update`,docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  
  GetDetailBpi  = async (numdoc) => {
    try {
      const response = await api.get(`/Document/GetDetails/${numdoc}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  
  UpdateDetailBpi  = async (docData) => {
    try {
      const response = await api.put(`/Document/IPM/updateBefore`,docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  deleteDoc  = async (numdoc) => {
    try {
      const response = await api.delete(`/Document/delete/${numdoc}/IPM/dev1`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };
  deleteFac  = async (num_facture) => {
    try {
      const response = await api.delete(`/Facture/Adherent/delete/${num_facture}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  deleteOrdrePaie  = async (numligne) => {
    try {
      const response = await api.delete(`/LettreCheque/delete/${numligne}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  

          getAllBci = async (selectedTypeDoc, selectedOption,years) => {
            try {
              const response = await api.get(`/Document/list/IPM/${years}/${selectedTypeDoc}-${selectedOption}`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
        

          getAllFacSoc = async (years) => {
            try {
              const response = await api.get(`/Facture/Adherent/list`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
          getAllEncaissement = async () => {
            try {
              const response = await api.get(`/Encaiss/List`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
          getAllODP = async (years) => {
            try {
              const response = await api.get(`/LettreCheque/list?annee=${years}`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };

          getPrintPdf  = async (numdoc) => {
            try {
              const response = await api.get(`/Print/Document/${numdoc}`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
      
}